/*
 * Copyright (c) 2019 - Bas Milius <bas@mili.us>
 *
 * This file is part of the Latte Framework package.
 *
 * For the full copyright and license information, please view the
 * LICENSE file that was distributed with this source code.
 */

Latte.core.register(Latte =>
{

	Latte.action.on("hub:installations:view-google-maps", data => window.open(`https://www.google.com/maps/search/?api=1&query=${data.lat},${data.long}`, "_blank"));

	Latte.action.on("hub:installations:copy", data =>
	{
		Latte.util.clipboard.copy(data.text);
		Latte.ui.snackbar.create({
			location: Latte.ui.snackbar.Locations.TOP,
			message: Latte.i18n.translate("hub-apps", "Copied to clipboard!")
		});
	});

});
